import React, { useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import { Formik, Form, Field } from "formik";
import config from "../../config/config";
import axios from "axios";

import { toastError, toastSuccess } from "../../common/Toast";
import Loader from "../Loader/Loader";

const EmailSettings = (props) => {
  const [visibleEmailSettings, setVisibleEmailSettings] = useState(false);
  const [formValues, setFormValues] = useState({
    SelectAProvider: "",
    EmailAddressGmail: "",
    EmailPasswordGmail: "",
    EmailAddressoffice365: "",
    EmailPasswordoffice365: "",
    EmailAddressHotmail: "",
    EmailPasswordHotmail: "",
    EmailAddressothermail: "",
    EmailPasswordothermail: "",
    SMTPEncryption: "",
    MailSendingProtocol: "",
    SMTPServerAddress: "",
    SMTPPort: "",
    CharacterSet: "",
    NewlineCharacter: "",
    CRLF: "",
    SMTPTimeout: "",
  });
  const [comingEmailSettings, setcomingEmailSettings] = useState(
    props.visibleEmailSettingsChange
  );
  const token = localStorage.getItem("Token");

  const [loading, setLoading] = useState(false);
  const [usesystemdefult, setusesystemdefult] = useState(true);
  const [gmailapi, setgmailapi] = useState(false);
  const [gmail, setgmail] = useState(false);
  const [office365, setoffice365] = useState(false);
  const [windowslivehotmail, setwindowslivehotmail] = useState(false);
  const [othermail, setothermail] = useState(false);

  const handleProvider = (e) => {
    if (e.target.value === "Gmail") {
      setgmail(true);
      setusesystemdefult(false);
      setgmailapi(false);
      setoffice365(false);
      setwindowslivehotmail(false);
      setothermail(false);
    } else if (e.target.value === "Office365") {
      setgmail(false);
      setusesystemdefult(false);
      setgmailapi(false);
      setoffice365(true);
      setwindowslivehotmail(false);
      setothermail(false);
    } else if (e.target.value === "Other") {
      setothermail(true);
      setgmail(false);
      setusesystemdefult(false);
      setgmailapi(false);
      setoffice365(true);
      setwindowslivehotmail(false);
    } else if (e.target.value === "WindowsLiveHotmail") {
      setothermail(false);
      setgmail(false);
      setusesystemdefult(false);
      setgmailapi(false);
      setoffice365(false);
      setwindowslivehotmail(true);
    } else if (e.target.value === "GmailAPI") {
      setothermail(false);
      setgmail(false);
      setusesystemdefult(false);
      setgmailapi(true);
      setoffice365(false);
      setwindowslivehotmail(false);
    } else {
      setothermail(false);
      setgmail(false);
      setusesystemdefult(true);
      setgmailapi(false);
      setoffice365(false);
      setwindowslivehotmail(false);
    }
  };

  const handleSubmit = (values) => {
    const formArray = [
      {
        AppConfigkey: "SelectAProvider",
        AppConfigvalue: values.SelectAProvider,
      },
      {
        AppConfigkey: "EmailAddressGmail",
        AppConfigvalue: values.EmailAddressGmail,
      },
      {
        AppConfigkey: "EmailPasswordGmail",
        AppConfigvalue: values.EmailPasswordGmail,
      },
      {
        AppConfigkey: "EmailAddressoffice365",
        AppConfigvalue: values.EmailAddressoffice365,
      },
      {
        AppConfigkey: "EmailPasswordoffice365",
        AppConfigvalue: values.EmailPasswordoffice365,
      },
      {
        AppConfigkey: "EmailAddressHotmail",
        AppConfigvalue: values.EmailAddressHotmail,
      },
      {
        AppConfigkey: "EmailPasswordHotmail",
        AppConfigvalue: values.EmailPasswordHotmail,
      },
      {
        AppConfigkey: "EmailAddressothermail",
        AppConfigvalue: values.EmailAddressothermail,
      },
      {
        AppConfigkey: "EmailPasswordothermail",
        AppConfigvalue: values.EmailPasswordothermail,
      },
      { AppConfigkey: "SMTPEncryption", AppConfigvalue: values.SMTPEncryption },
      {
        AppConfigkey: "MailSendingProtocol",
        AppConfigvalue: values.MailSendingProtocol,
      },
      {
        AppConfigkey: "SMTPServerAddress",
        AppConfigvalue: values.SMTPServerAddress,
      },
      { AppConfigkey: "SMTPPort", AppConfigvalue: values.SMTPPort },
      { AppConfigkey: "CharacterSet", AppConfigvalue: values.CharacterSet },
      {
        AppConfigkey: "NewlineCharacter",
        AppConfigvalue: values.NewlineCharacter,
      },
      { AppConfigkey: "CRLF", AppConfigvalue: values.CRLF },
      { AppConfigkey: "SMTPTimeout", AppConfigvalue: values.SMTPTimeout },
    ];

    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "EmailSettings",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess("Record has been added!");
        } else {
          toastError("Somthing went wrong");
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  //handleChange
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: fieldValue,
    }));
  };

  useEffect(() => {
    setLoading(true);

    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=EmailSettings`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;

        responseData.map((data) => {
          if (data.AppConfigkey === "SelectAProvider") {
            formValues.SelectAProvider = data.AppConfigvalue;
          } else if (data.AppConfigkey === "EmailAddressGmail") {
            formValues.EmailAddressGmail = data.AppConfigvalue;
          } else if (data.AppConfigkey === "EmailPasswordGmail") {
            formValues.EmailPasswordGmail = data.AppConfigvalue;
          } else if (data.AppConfigkey === "EmailAddressoffice365") {
            formValues.EmailAddressoffice365 = data.AppConfigvalue;
          } else if (data.AppConfigkey === "EmailPasswordoffice365") {
            formValues.EmailPasswordoffice365 = data.AppConfigvalue;
          } else if (data.AppConfigkey === "EmailAddressHotmail") {
            formValues.EmailAddressHotmail = data.AppConfigvalue;
          } else if (data.AppConfigkey === "EmailPasswordHotmail") {
            formValues.EmailPasswordHotmail = data.AppConfigvalue;
          } else if (data.AppConfigkey === "EmailAddressothermail") {
            formValues.EmailAddressothermail = data.AppConfigvalue;
          } else if (data.AppConfigkey === "EmailPasswordothermail") {
            formValues.EmailPasswordothermail = data.AppConfigvalue;
          } else if (data.AppConfigkey === "SMTPEncryption") {
            formValues.SMTPEncryption = data.AppConfigvalue;
          } else if (data.AppConfigkey === "MailSendingProtocol") {
            formValues.MailSendingProtocol = data.AppConfigvalue;
          } else if (data.AppConfigkey === "SMTPServerAddress") {
            formValues.SMTPServerAddress = data.AppConfigvalue;
          } else if (data.AppConfigkey === "SMTPPort") {
            formValues.SMTPPort = data.AppConfigvalue;
          } else if (data.AppConfigkey === "NewlineCharacter") {
            formValues.NewlineCharacter = data.AppConfigvalue;
          } else if (data.AppConfigkey === "CRLF") {
            formValues.CRLF = data.AppConfigvalue;
          } else if (data.AppConfigkey === "SMTPTimeout") {
            formValues.SMTPTimeout = data.AppConfigvalue;
          }
        });

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const data = [
    {
      name: "Select A Provider:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="select"
                className="form-control form-small select"
                id="SelectAProvider"
                name="SelectAProvider"
                onInput={handleProvider}
                onChange={handleChange}
              >
                <option value="UseSystemDefault">Use System Default</option>
                <option value="GmailAPI">Gmail API</option>
                <option value="Gmail">Gmail</option>
                <option value="Office365">Office 365</option>
                <option value="WindowsLiveHotmail">Windows Live Hotmail</option>
                <option value="Other">Other</option>
              </Field>
            </div>
          </div>
          <div
            className={`form-group row ${othermail === true ? "" : "d-none"}`}
          >
            <label className="col-form-label col-lg-2">Email Address:</label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="EmailAddressothermail"
                  name="EmailAddressothermail"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${othermail === true ? "" : "d-none"}`}
          >
            <label className="col-form-label col-lg-2">Email Password:</label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="EmailPasswordothermail"
                  name="EmailPasswordothermail"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${othermail === true ? "" : "d-none"}`}
          >
            <label className="col-form-label col-lg-2">SMTP Encryption:</label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  as="select"
                  className="form-control form-small select"
                  id="SMTPEncryption"
                  name="SMTPEncryption"
                  onChange={handleChange}
                >
                  <option></option>
                  <option>ssl</option>
                  <option>tsl</option>
                </Field>
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${othermail === true ? "" : "d-none"}`}
          >
            <label className="col-form-label col-lg-2">
              Mail Sending Protocol:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  as="select"
                  className="form-control form-small select"
                  id="MailSendingProtocol"
                  name="MailSendingProtocol"
                  onChange={handleChange}
                >
                  <option></option>
                  <option>smtp</option>
                  <option>mail</option>
                  <option>sendmail</option>
                </Field>
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${othermail === true ? "" : "d-none"}`}
          >
            <label className="col-form-label col-lg-2">
              SMTP Server Address:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="SMTPServerAddress"
                  name="SMTPServerAddress"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${othermail === true ? "" : "d-none"}`}
          >
            <label className="col-form-label col-lg-2">SMTP Port:</label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="SMTPPort"
                  name="SMTPPort"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${othermail === true ? "" : "d-none"}`}
          >
            <label className="col-form-label col-lg-2">Character Set:</label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="CharacterSet"
                  name="CharacterSet"
                  placeholder="utf-8"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${othermail === true ? "" : "d-none"}`}
          >
            <label className="col-form-label col-lg-2">
              Newline Character:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  as="select"
                  className="form-control form-small select"
                  id="NewlineCharacter"
                  name="NewlineCharacter"
                  onChange={handleChange}
                >
                  <option>\r\n</option>
                  <option>\n</option>
                  <option>\r</option>
                </Field>
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${othermail === true ? "" : "d-none"}`}
          >
            <label className="col-form-label col-lg-2">CRLF:</label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  as="select"
                  className="form-control form-small select"
                  id="CRLF"
                  name="CRLF"
                  onChange={handleChange}
                >
                  <option>\r\n</option>
                  <option>\n</option>
                  <option>\r</option>
                </Field>
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${othermail === true ? "" : "d-none"}`}
          >
            <label className="col-form-label col-lg-2">SMTP Timeout:</label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="SMTPTimeout"
                  name="SMTPTimeout"
                  placeholder="5"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];

  const matchesSearchQuery = data?.filter((el) => {
    return el?.name?.toLowerCase().includes(props.searchQuery.toLowerCase());
  });

  return (
    <>
      {/*  */}
      {/* <Loader loading={loading} /> */}
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div
            style={{ padding: "0px", marginTop: "16px", marginLeft: "18px" }}
            className="card-header"
          >
            <h5 className="card-title">
              <CLink
                style={{ color: "var(--primary-main-color)" }}
                onClick={() => {
                  setVisibleEmailSettings(!visibleEmailSettings);
                  setcomingEmailSettings(!!comingEmailSettings);
                }}
              >
                Email Settings
              </CLink>
            </h5>
          </div>
          <CCollapse
            visible={visibleEmailSettings || props.visibleEmailSettingsChange}
          >
            <div className="card-body">
              <Formik
                {...props}
                initialValues={formValues}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ handleChange }) => (
                  <Form>
                    <div
                      style={{
                        display: "flex",
                        width: "30%",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      {matchesSearchQuery &&
                        matchesSearchQuery?.map((el) => (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "10px",
                            }}
                          >
                            <label
                              className="col-form-label"
                              style={{ fontSize: "15px" }}
                            >
                              {el.name}
                            </label>
                            <div style={{ width: "53%" }}>{el.input}</div>
                          </div>
                        ))}
                    </div>
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Select A Provider:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="SelectAProvider"
                          name="SelectAProvider"
                          onInput={handleProvider}
                          onChange={handleChange}
                        >
                          <option value="UseSystemDefault">
                            Use System Default
                          </option>
                          <option value="GmailAPI">Gmail API</option>
                          <option value="Gmail">Gmail</option>
                          <option value="Office365">Office 365</option>
                          <option value="WindowsLiveHotmail">
                            Windows Live Hotmail
                          </option>
                          <option value="Other">Other</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}

                    {/* Gmail */}
                    {/* <div
                    className={`form-group row ${gmail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Address:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailAddressGmail"
                          name="EmailAddressGmail"
                          placeholder="username@gmail.com"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${gmail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Password:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailPasswordGmail"
                          name="EmailPasswordGmail"
                          placeholder="password"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}

                    {/* office 365 */}
                    {/* <div
                    className={`form-group row ${office365 === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Address:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailAddressoffice365"
                          name="EmailAddressoffice365"
                          placeholder="username@gmail.com"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${office365 === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Password:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailPasswordoffice365"
                          name="EmailPasswordoffice365"
                          placeholder="password"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}

                    {/* Windows Live Hotmail */}
                    {/* <div
                    className={`form-group row ${windowslivehotmail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Address:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailAddressHotmail"
                          name="EmailAddressHotmail"
                          placeholder="username@gmail.com"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${windowslivehotmail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Password:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailPasswordHotmail"
                          name="EmailPasswordHotmail"
                          placeholder="password"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}

                    {/* other */}
                    {/* <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Address:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailAddressothermail"
                          name="EmailAddressothermail"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Password:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailPasswordothermail"
                          name="EmailPasswordothermail"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      SMTP Encryption:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="SMTPEncryption"
                          name="SMTPEncryption"
                          onChange={handleChange}
                        >
                          <option></option>
                          <option>ssl</option>
                          <option>tsl</option>
                        </Field>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Mail Sending Protocol:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="MailSendingProtocol"
                          name="MailSendingProtocol"
                          onChange={handleChange}
                        >
                          <option></option>
                          <option>smtp</option>
                          <option>mail</option>
                          <option>sendmail</option>
                        </Field>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      SMTP Server Address:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="SMTPServerAddress"
                          name="SMTPServerAddress"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      SMTP Port:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="SMTPPort"
                          name="SMTPPort"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Character Set:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="CharacterSet"
                          name="CharacterSet"
                          placeholder="utf-8"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Newline Character:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="NewlineCharacter"
                          name="NewlineCharacter"
                          onChange={handleChange}
                        >
                          <option>\r\n</option>
                          <option>\n</option>
                          <option>\r</option>
                        </Field>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">CRLF:</label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="CRLF"
                          name="CRLF"
                          onChange={handleChange}
                        >
                          <option>\r\n</option>
                          <option>\n</option>
                          <option>\r</option>
                        </Field>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      SMTP Timeout:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="SMTPTimeout"
                          name="SMTPTimeout"
                          placeholder="5"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}

                    <button
                      type="submit"
                      className="btn btn-primary pull-right mb-3"
                    >
                      Save
                    </button>
                    {/* <button type="button" className="btn btn-primary me-1 pull-right mb-3">
                                        <i className="fa fa-envelope"></i>
                                        &nbsp; Send Test Email
                                    </button> */}
                  </Form>
                )}
              </Formik>
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  onClick={() => {
                    setVisibleEmailSettings(!visibleEmailSettings);
                    setcomingEmailSettings(!!comingEmailSettings);
                  }}
                >
                  Email Settings
                </CLink>
              </h5>
            </div>
            <CCollapse
              visible={visibleEmailSettings || props.visibleEmailSettingsChange}
            >
              <div className="card-body">
                <Formik
                  {...props}
                  initialValues={formValues}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({ handleChange }) => (
                    <Form>
                      <div
                        style={{
                          display: "flex",
                          width: "40%",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        {matchesSearchQuery &&
                          matchesSearchQuery?.map((el) => (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "10px",
                              }}
                            >
                              <label
                                className="col-form-label"
                                style={{ fontSize: "15px" }}
                              >
                                {el.name}
                              </label>
                              <div style={{ width: "53%" }}>{el.input}</div>
                            </div>
                          ))}
                      </div>
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Select A Provider:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="SelectAProvider"
                          name="SelectAProvider"
                          onInput={handleProvider}
                          onChange={handleChange}
                        >
                          <option value="UseSystemDefault">
                            Use System Default
                          </option>
                          <option value="GmailAPI">Gmail API</option>
                          <option value="Gmail">Gmail</option>
                          <option value="Office365">Office 365</option>
                          <option value="WindowsLiveHotmail">
                            Windows Live Hotmail
                          </option>
                          <option value="Other">Other</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}

                      {/* Gmail */}
                      {/* <div
                    className={`form-group row ${gmail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Address:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailAddressGmail"
                          name="EmailAddressGmail"
                          placeholder="username@gmail.com"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${gmail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Password:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailPasswordGmail"
                          name="EmailPasswordGmail"
                          placeholder="password"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}

                      {/* office 365 */}
                      {/* <div
                    className={`form-group row ${office365 === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Address:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailAddressoffice365"
                          name="EmailAddressoffice365"
                          placeholder="username@gmail.com"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${office365 === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Password:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailPasswordoffice365"
                          name="EmailPasswordoffice365"
                          placeholder="password"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}

                      {/* Windows Live Hotmail */}
                      {/* <div
                    className={`form-group row ${windowslivehotmail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Address:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailAddressHotmail"
                          name="EmailAddressHotmail"
                          placeholder="username@gmail.com"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${windowslivehotmail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Password:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailPasswordHotmail"
                          name="EmailPasswordHotmail"
                          placeholder="password"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}

                      {/* other */}
                      {/* <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Address:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailAddressothermail"
                          name="EmailAddressothermail"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Email Password:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="EmailPasswordothermail"
                          name="EmailPasswordothermail"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      SMTP Encryption:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="SMTPEncryption"
                          name="SMTPEncryption"
                          onChange={handleChange}
                        >
                          <option></option>
                          <option>ssl</option>
                          <option>tsl</option>
                        </Field>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Mail Sending Protocol:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="MailSendingProtocol"
                          name="MailSendingProtocol"
                          onChange={handleChange}
                        >
                          <option></option>
                          <option>smtp</option>
                          <option>mail</option>
                          <option>sendmail</option>
                        </Field>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      SMTP Server Address:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="SMTPServerAddress"
                          name="SMTPServerAddress"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      SMTP Port:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="SMTPPort"
                          name="SMTPPort"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Character Set:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="CharacterSet"
                          name="CharacterSet"
                          placeholder="utf-8"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Newline Character:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="NewlineCharacter"
                          name="NewlineCharacter"
                          onChange={handleChange}
                        >
                          <option>\r\n</option>
                          <option>\n</option>
                          <option>\r</option>
                        </Field>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">CRLF:</label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="CRLF"
                          name="CRLF"
                          onChange={handleChange}
                        >
                          <option>\r\n</option>
                          <option>\n</option>
                          <option>\r</option>
                        </Field>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`form-group row ${othermail === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      SMTP Timeout:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="SMTPTimeout"
                          name="SMTPTimeout"
                          placeholder="5"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}

                      <button
                        type="submit"
                        className="btn btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                      {/* <button type="button" className="btn btn-primary me-1 pull-right mb-3">
                                        <i className="fa fa-envelope"></i>
                                        &nbsp; Send Test Email
                                    </button> */}
                    </Form>
                  )}
                </Formik>
              </div>
            </CCollapse>
          </div>
        )
      )}
    </>
  );
};

export default EmailSettings;
